import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "element-box mx-auto",
  style: {"width":"80%"}
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom" }
const _hoisted_5 = { class: "fw-bold text-secondary mb-0" }
const _hoisted_6 = { class: "text-center px-3 mx-auto" }
const _hoisted_7 = {
  class: "text-danger fw-bold pulse-animation",
  style: {"font-size":"16px"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = { class: "col-md-6 mb-2" }
const _hoisted_11 = { class: "h5 fw-normal text-dark" }
const _hoisted_12 = { class: "border-top pt-4" }
const _hoisted_13 = { class: "fw-bold text-secondary mb-3" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-2 mb-3" }
const _hoisted_16 = { class: "text-dark" }
const _hoisted_17 = { class: "col-md-2 mb-3" }
const _hoisted_18 = { class: "text-dark" }
const _hoisted_19 = { class: "table-responsive overflow-auto mt-5" }
const _hoisted_20 = { class: "table table-striped" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = {
  key: 0,
  style: {"color":"#cf1020"}
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = ["onClick"]

import portalCMCService from "@/api/Portal/CaseManagementCoaching";
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import {onMounted, ref, watch} from 'vue';
import {useRoute} from 'vue-router';
import RemoteDigitalSignatureForm
  from "@/views/App/Portal/CaseManagementCoaching/RemoteDigitalSignature/RemoteDigitalSignatureForm.vue";

interface ICompany {
  color: string;
  logo: string,
}

interface IUnemployed {
  firstName: string;
  lastName: string,
  address: string,
  city: string,
  zip: string,
  aaNumber: string,
  insuranceNumber: string,
  email: string,
  phone: string,
}

interface ICalculatedUnits {
  unitsDone: number;
  maxUnits: number;
}

interface ICoaching {
  startDate: string;
  endDate: string;
  calculatedUnits: ICalculatedUnits | null;
}

export interface IMeeting {
  id: number;
  termin: string;
  startTime: string;
  endTime: string;
  presenceTranslation: string;
  units: number;
  moduleName: string;
  digitalSignature: string | null;
  homeVisit: boolean;
  meetingType: string;
  coach?: {
    fullName: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoteMeetings',
  setup(__props) {

const route = useRoute();

const company = ref<ICompany | null>(null);
const unemployed = ref<IUnemployed | null>(null);
const coaching = ref<ICoaching | null>(null);
const meetings = ref<IMeeting[]>([])
const meetingId = ref<number | null>(null);
const meetingType = ref<string>("")

const tokenExpiresAt = ref('')
const isLoaded = ref(false);
const showDigitalSignatureModal = ref(false);
const submitForm = ref(false);
const token = route.params.token as string;

watch(submitForm, () => {
  meetingId.value = null;
  showDigitalSignatureModal.value = false;
  getData();
});

async function getData() {
  try {
    const {data} = await portalCMCService.getCmcRemoteMeetings(token);
    coaching.value = data.data?.coaching
    unemployed.value = data.data?.unemployed
    company.value = data.data?.company
    tokenExpiresAt.value = data.data?.expiresAt
    meetings.value = data.data?.meetings
  } catch (error) {
    await ErrorToast(error);
  }
}

function handleDigitalSignatureModal(id: number, type: string) {
  CloseToast();
  meetingId.value = id;
  meetingType.value = type;
  showDigitalSignatureModal.value = true;
}

onMounted(async () => {
  await getData()
  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "row m-0 p-3 bg-white rounded shadow-sm",
                style: _normalizeStyle({
              'border': `1px solid ${company.value?.color} !important`,
              'border-top': `3px solid ${company.value?.color} !important`
              })
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h5", _hoisted_5, [
                      _createElementVNode("i", {
                        class: "os-icon os-icon-user me-2",
                        style: _normalizeStyle({ color: company.value?.color })
                      }, null, 4),
                      _cache[2] || (_cache[2] = _createTextVNode("Benutzerdaten ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "os-icon os-icon-clock me-1" }, null, -1)),
                        _createTextVNode("Link gültig bis: " + _toDisplayString(tokenExpiresAt.value || 'Keine Angaben'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: company.value?.logo,
                        alt: "Logo",
                        style: {"max-height":"50px","width":"auto","object-fit":"contain"}
                      }, null, 8, _hoisted_8)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[4] || (_cache[4] = _createElementVNode("small", { class: "text-muted d-block text-uppercase fw-bold tracking-wider" }, "Vor- und Nachname", -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(unemployed.value?.firstName) + " " + _toDisplayString(unemployed.value?.lastName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h6", _hoisted_13, [
                      _createElementVNode("i", {
                        class: "os-icon os-icon-trending-up me-2",
                        style: _normalizeStyle({ color: company.value?.color })
                      }, null, 4),
                      _cache[5] || (_cache[5] = _createTextVNode("Coaching-Daten ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted d-block text-uppercase fw-bold tracking-wider" }, "Startdatum", -1)),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(coaching.value?.startDate || 'Keine Angaben'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted d-block text-uppercase fw-bold tracking-wider" }, "Enddatum", -1)),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(coaching.value?.endDate || 'Keine Angaben'), 1)
                      ])
                    ])
                  ])
                ])
              ], 4),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  _createElementVNode("thead", {
                    style: _normalizeStyle({
                    borderBottom: `3px solid ${company.value?.color}`,
                    color: 'black'
                })
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "py-2 px-2",
                        style: {"font-size":"12px"}
                      }, "Termin"),
                      _createElementVNode("th", {
                        class: "py-2 px-2",
                        style: {"font-size":"12px"}
                      }, "Startzeit"),
                      _createElementVNode("th", {
                        class: "py-2 px-2",
                        style: {"font-size":"12px"}
                      }, "Endzeit"),
                      _createElementVNode("th", {
                        class: "py-2 px-2",
                        style: {"font-size":"12px"}
                      }, "Anwesenheit"),
                      _createElementVNode("th", {
                        class: "text-end py-2 px-2",
                        style: {"font-size":"12px"}
                      }, "Einheiten"),
                      _createElementVNode("th", {
                        class: "text-center py-2 px-2",
                        style: {"font-size":"12px"}
                      }, "Unterschrift"),
                      _createElementVNode("th")
                    ], -1)
                  ]))], 4),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meetings.value, (meeting) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: meeting.id
                      }, [
                        _createElementVNode("th", null, _toDisplayString(meeting?.termin), 1),
                        _createElementVNode("td", null, _toDisplayString(meeting?.startTime), 1),
                        _createElementVNode("td", null, _toDisplayString(meeting?.endTime), 1),
                        _createElementVNode("td", null, _toDisplayString(meeting?.presenceTranslation), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(meeting?.units), 1),
                        _createElementVNode("td", _hoisted_22, [
                          (!meeting.digitalSignature)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Fehlende Digitale Unterschrift "))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                style: {"min-width":"200px"},
                                height: "60",
                                src: meeting.digitalSignature
                              }, null, 8, _hoisted_24))
                        ]),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _withModifiers(($event: any) => (handleDigitalSignatureModal(
                            meeting?.id,
                            meeting.meetingType
                            )), ["stop"])
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1),
                            _createTextVNode(" Digitale Unterschrift ", -1)
                          ]))], 8, _hoisted_26)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode(Modal, {
              modelValue: showDigitalSignatureModal.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDigitalSignatureModal).value = $event)),
              title: "Digitale Unterschrift",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              sizeModal: "modal-md",
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(RemoteDigitalSignatureForm, {
                  token: _unref(token),
                  meetingId: meetingId.value,
                  meetingType: meetingType.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[0] || (_cache[0] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["token", "meetingId", "meetingType", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"])
          ]))
    ]),
    _: 1
  }))
}
}

})